import React, { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import Siderbar from '../Sidebar/Siderbar'
import { useNavigate, Link } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { getnotification } from '../../ReduxToolkit/Slice/Notification/Notification';

function Navbar() {
  const Navigate = useNavigate()
  const dispatch = useDispatch();
  const { status, notifications } = useSelector((state) => state.notification || { status: 'idle', notification: { data: [] } });
  useEffect(() => {
    if (status === "idle") {
      dispatch(getnotification())
    }
  }, [dispatch, status]);

  const logout = () => {
    sessionStorage.removeItem('accessToken')
    Navigate('/signin')
  }
  return (
    <>
      <div className='d-flex justify-content-between p-2'>
        <span
          className="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none"
        >
          <>
            <span className='d-lg-none'>
              <span><i className='bi bi-list fs-2 me-2 text-white' data-bs-toggle="offcanvas" href="#offcanvasExample"></i></span>
              <span className="fs-5 fw-bold text-white">Admin</span>
            </span>
          </>
        </span>
        <div className="mx-3 mx-md-5 cursor py-1">
          <Link to="/notification"> <div className="bi bi-bell-fill position-relative fs-5 text-white">
            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: "12px" }}>
              {notifications.data ? notifications.data.length : ""}
            </span>
          </div></Link>
        </div>
        <div className="dropdown">
          <NavLink
            to="/"
            className="d-flex align-items-center text-white text-decoration-none dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
           <i className='bi bi-person-circle fs-3 mx-1'></i>
            <strong>Daksh College</strong>
          </NavLink>
          <ul className="dropdown-menu text-small shadow">
            {/* <li>
              <NavLink className="dropdown-item" to="/c">
                Profile
              </NavLink>
            </li> */}

            <li onClick={logout}>
              <NavLink className="dropdown-item" to="/signin">
                Sign out
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
      {/* mobile menu */}


      <div className="offcanvas offcanvas-start  bg-primary" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel" style={{ width: "70vw" }}>

        <div className="offcanvas-body">
          {/* <i className="bi bi-x btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></i> */}
          <div data-bs-dismiss="offcanvas">
            <Siderbar />
          </div>

        </div>
      </div>
    </>

  )
}

export default Navbar